<mat-radio-button
  [value]="node"
  color="primary"
  [checked]="selectedNode && selectedNode.id == node.id"
  (change)="onSelect($event)"
>
  <div class="container-node d-flex flex-column align-items-start justify-content-center">
    <b>{{ title }}</b>
    <div class="font-08rem">{{ subtitle }}</div>
  </div>
</mat-radio-button>
